import React from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import Chip from '@mui/material/Chip';
import './ProjectFilter.scss';

const ProjectFilter = ({ filter, setFilter }) => {
    
    React.useEffect(() => {
        AOS.init();
        AOS.refresh();
    }, []);

    const selectFilter = (num,filter) => {

        setFilter(filter);

        const filterDiv = document.querySelectorAll('.project-filter>div');

        for(let i=0; i<filterDiv.length; i++) {
            filterDiv[i].classList.remove('active');
        }

        filterDiv[num].classList.add('active');
    }

    return (

        <div className="project-filter">
            <Chip label="All" variant="outlined" onClick={() => selectFilter(0,'all')} className="active" />
            <Chip label="Mern" variant="outlined" onClick={() => selectFilter(1,'mern')} className="" />
            <Chip label="React" variant="outlined" onClick={() => selectFilter(2,'react')} className="" />
            <Chip label="Node.js" variant="outlined" onClick={() => selectFilter(3,'node')} className="" />
            <Chip label="Backend Api" variant="outlined" onClick={() => selectFilter(4,'backend')} className="" />
            <Chip label="JavaScript" variant="outlined" onClick={() => selectFilter(5,'javascript')} className="" />
            <Chip label="Bootstrap" variant="outlined" onClick={() => selectFilter(6,'bootstrap')} className="" />
            <Chip label="Cli" variant="outlined" onClick={() => selectFilter(7,'cli')} className="" />
        </div>
    );
}

export default ProjectFilter;